import api from "@/repo/api";
import Vue from "vue";
import {$http} from "@/repo/request";

class EcApply {
    constructor() {

    }

    data = Vue.observable({
        step: 0,
        ready: false,
        business_code: '',
        created_at: '',
        applyment_state: '',
    })

    apply = Vue.observable({})

    $loading = Vue.$loading
    tmFlag = null

    uploadIdCardAUrl = api.colUrl('/ec-pay-apply/upload-id-card-a')

    uploadIdCardBUrl = api.colUrl('/ec-pay-apply/upload-id-card-b')

    uploadMediaUrl = api.colUrl('/ec-pay-apply/upload-media')


    organizationTypes = [
        {
            value: '2401',
            label: '个人',
            summary: '个人卖家，无营业执照的个人商家',
            icon: "/assets/icons/type-card-gr.png"
        },
        {
            value: '4',
            label: '个体工商户',
            summary: '营业执照上的主体类型一般为个体户、个体工商户、个体经营',
            icon: "/assets/icons/type-card-gr.png"
        },
        {
            value: '2',
            label: '企业',
            summary: '营业执照上的主体类型一般为企业、有限责任公司、股份有限公司、合伙企业',
            icon: "/assets/icons/type-card-qy.png"
        }
    ]


    init() {
        this.fetchApply()
    }

    organizationTypeText() {
        return this.organizationTypeItem().label || '未选择'
    }

    isPerson() {
        return this.apply.organization_type === '2401'
    }

    isCompany() {
        return this.apply.organization_type === '2'
    }

    organizationTypeItem() {
        const type = this.apply.organization_type

        if (!type) return {}

        const result = this.organizationTypes.find(item => item.value === type);

        return result || {}
    }

    fetchApply(repeat = false) {

        if (!repeat) this.$loading.show()

        api.get('/ec-pay-apply/apply').then(data => {

            this.$loading.hide()

            this.loadApply(data.data)

            this.data.applyment_state = data.data.applyment_state || ''

            if (data.data.applyment_state === 'APPLYMENT_STATE_FINISHED') return;

            if (this.data.step === 7) this.tmFlag = setTimeout(() => {
                this.fetchApply(true)
            }, 5000)

            this.data.ready = true
        })

    }

    destroy() {
        if (this.tmFlag) clearTimeout(this.tmFlag)
    }

    gotoStep(step, refreshData = false) {

        this.data.step = step

        if (refreshData) this.loadApply(refreshData)

        console.log('gotoStep', step)
    }

    loadApply(data) {

        let apply = data.info || {}

        this.data.business_code = data.business_code || ''
        this.data.created_at = data.created_at || ''

        this.apply = Vue.observable({
            ...this.apply,
            ...apply
        })

        if (apply.bank_account_info) {

            if (apply.bank_account_info.account_bank !== '其他银行') {
                delete apply.bank_account_info.bank_name
            }
        }

        if (data.applyment_id) {
            this.gotoStep(7)
        } else {
            this.gotoStep(apply && apply['organization_type'] ? 2 : 1)
        }
    }

    getApplyValue(key, defaultValue = null) {

        // 将 key 按点分割成数组
        const keys = key.split('.');

        // 从 this.apply 对象开始查找
        let current = this.apply;

        // 遍历分割后的 key 数组
        for (const k of keys) {
            if (current && typeof current === 'object' && k in current) {
                // 如果当前对象存在且包含当前 key，则继续深入查找
                current = current[k];
            } else {
                // 若值不存在，返回默认值
                return defaultValue;
            }
        }

        // 返回最终找到的值
        return current;

    }

    initApply(type) {

        this.$loading.show()

        api.post('/ec-pay-apply/init-apply', {
            organization_type: type
        }).then((data) => {

            this.$loading.hide()

            if (data.code === 0) {

                this.apply = Vue.observable({
                    organization_type: type,
                })

                this.gotoStep(2)

            } else {

                this.$message.error('修改失败');

            }

        })
    }

    async bankSearch(keyword, type) {

        const {data} = await $http.post(api.colUrl('/ec-pay-apply/bank-search'), {
            keyword,
            type
        })

        return data
    }

}


export default new EcApply()